import { Collection } from "./Collection";
import { ETemperatureSensorType } from "./ETemperatureSensorType";
import { ETemperatureState } from "./ETemperatureState";
export interface TemperatureData {
  values: number[];
  time: string;
}

export interface TemperatureLog {
  sensorNames: string[];
  data: TemperatureData[];
}

export interface TemperatureReading {
  sensorName: string;
  value: number;
}

export interface TemperatureSensor {
  name: string;
  id: number;
  type: ETemperatureSensorType;
  violationCheck: boolean;
  includedInAverage: boolean;
  isPhysicalSensor: boolean;
}

export enum ETemperatureControlFeature {
  Unknown = 0,
  Fan,
  Heater,
}

export interface ModuleTemperatureSensor {
  identifier: string;
  temperatureSensors: TemperatureSensor[];
  temperatureReading: { [index: string]: number };
}

export interface TemperatureSensorCollection {
  identifier: string;
  temperatureSensorCollection: Collection<TemperatureSensor>;
  temperatureSensors: TemperatureSensor[];
}

export interface ModuleTemperatureSensorCollection {
  allIds: string[];
  byId: { [index: string]: TemperatureSensorCollection };
}

export interface ModuleTemperatureChange {
  identifier: string;
  time: string;
  data: { [index: string]: number };
  state: ETemperatureState;
}
